import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { WizardContextProvider } from './contexts/WizardContext';
import { MediaQueryContextProvider } from './contexts/MediaQueryContext';
import * as serviceWorker from './serviceWorker';

import './index.scss';

import { AnonymousAuthContextProvider } from './contexts/AnonymousAuthContext';

// TODO: Implement AnonymousAuthContext that:
//  - displays loading during initialisation
//  - signs in anonymously the user / set persistence to local
//  - if there is a session, don't sign in
//  - else sign in
//  - once signed in, remove loading


ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <MediaQueryContextProvider>
        <AnonymousAuthContextProvider>
          <WizardContextProvider>
            <App/>
          </WizardContextProvider>
        </AnonymousAuthContextProvider>
      </MediaQueryContextProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
